export const MESSAGE_TABS = Object.freeze({
  INBOX: 'inbox',
  INBOX_API_FAILED: 'api_failed',
  COMPLETE: 'complete'
});

export const MESSAGE_STATUSES = Object.freeze({
  CSR_ACTION_REQUIRED: 'CSR_ACTION_REQUIRED',
  COMPLETE: 'COMPLETE'
});

export const MESSAGE_PLACEHOLDERS = Object.freeze({
  SEARCH_BAR: 'Search CRM case number',
  CRM_CASE_ID_INPUT: 'Enter 5-10 digits'
});

export const MESSAGE_ERRORS = Object.freeze({
  CRM_CASE_ID_NOT_EXIST: 'This case number does not exist in the CRM',
  SEND_REPLY_NOT_IN_THREAD: 'The case number you entered does not belong to this message thread.',
  SEND_REPLY_CRM_APIS_OFFLINE: 'We\'re unable to validate this case number.'
});

export const MESSAGE_TYPE_KEYS = Object.freeze({
  REPLY: 'ReplyMessage',
  MESSAGE: 'Message',
});

export const MESSAGE_CRM_CASE_ID_API_FAILED = 'API_FAILED';